import { AppNavigationWrapper } from './AppNavigation.style';
import { ReactComponent as mdjs } from 'assets/icons/logos/mdjs.svg';
import { ReactComponent as ForbiddenToMinors } from 'assets/icons/logos/forbiddenToMinors.svg';
import { REACT_APP_MAIN_SITE_HOMEPAGE } from 'config';
import Icon from 'components/Icon/Icon';

function AppNavigation() {
  return (
    <AppNavigationWrapper>
      <a href={REACT_APP_MAIN_SITE_HOMEPAGE}>
        <Icon iconSize="7.2rem" iconHeight="3.8rem" svgIconComponent={mdjs} />
      </a>
      <ForbiddenToMinors />
    </AppNavigationWrapper>
  );
}

export default AppNavigation;
